// Preserve the actual page and its template/artist query when Shopify's native
// localization form submits. Shopify controls language selection and persistence.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('art-language-form')) return;
  let returnTo = form.querySelector('input[name="return_to"]');
  if (!returnTo) {
    returnTo = document.createElement('input');
    returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo);
  }
  returnTo.value = location.pathname + location.search + location.hash;
});

// Jump between translations without changing the store language or hiding text.
(() => {
  function addJumps(group, english, hebrew, heading) {
    if (!english || !hebrew || group.dataset.languageJumps) return;
    group.dataset.languageJumps = 'true';
    const key = document.querySelectorAll('[data-language-jumps]').length;
    const nav = document.createElement('nav');
    nav.className = 'art-language-jumps'; nav.setAttribute('aria-label', 'Read in your language');
    for (const [target, label, language] of [[english, 'English', 'en'], [hebrew, 'עברית', 'he']]) {
      if (!target.id) target.id = `art-reading-${language}-${key}`;
      const link = document.createElement('a');
      link.href = `#${target.id}`; link.textContent = label; link.lang = language;
      link.addEventListener('click', event => {
        event.preventDefault();
        const header = document.querySelector('[id^="shopify-section-"][id$="__header"]');
        const top = target.getBoundingClientRect().top + window.scrollY - (header?.getBoundingClientRect().height || 0) - 20;
        window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      nav.append(link);
    }
    if (heading) heading.after(nav); else group.before(nav);
  }
  function initializeJumps() {
    document.querySelectorAll('.art-about__introduction').forEach(group => addJumps(group, group.querySelector('[lang="en"]'), group.querySelector('[lang="he"]'), group.querySelector('h1')));
    document.querySelectorAll('.art-fund__investment').forEach(group => addJumps(group, group.querySelector('.art-fund__vogel-copy[lang="en"]'), group.querySelector('.art-fund__vogel-copy[lang="he"]'), group.querySelector('h2')));
    document.querySelectorAll('.art-fund__languages').forEach(group => addJumps(group, group.querySelector('[lang="en"]'), group.querySelector('[lang="he"]')));
    document.querySelectorAll('.art-past-auctions').forEach(group => addJumps(group, group.querySelector('[lang="en"]'), group.querySelector('[lang="he"]'), group.querySelector('h1')));
    document.querySelectorAll('.art-policy-columns').forEach(group => addJumps(group, group.querySelector('[dir="ltr"]'), group.querySelector('[dir="rtl"]'), document.querySelector('.shopify-policy__title h1')));
    document.querySelectorAll('.art-artist-description').forEach(group => {
      const paragraphs = [...group.querySelectorAll('p,h2,h3')];
      const hebrew = paragraphs.find(node => (node.textContent.match(/[\u0590-\u05ff]/g) || []).length > 30);
      const english = paragraphs.find(node => (node.textContent.match(/[a-z]/gi) || []).length > 60 && (node.textContent.match(/[\u0590-\u05ff]/g) || []).length === 0);
      addJumps(group, english, hebrew, group.closest('main')?.querySelector('h1'));
    });
  }
  const styles = document.createElement('style');
  styles.textContent = '.art-language-jumps{display:flex;justify-content:center;gap:24px;direction:ltr;margin:16px 0 28px;font:inherit;font-size:20px;color:#000;grid-column:1/-1}.art-language-jumps a{color:inherit;text-decoration:underline;text-underline-offset:4px}.art-language-jumps a:focus-visible{outline:2px solid currentColor;outline-offset:5px}';
  document.head.append(styles);
  initializeJumps();
  let queued = false;
  const main = document.querySelector('main');
  if (main) new MutationObserver(() => {
    if (queued) return;
    queued = true; requestAnimationFrame(() => { queued = false; initializeJumps(); });
  }).observe(main, { childList:true, subtree:true });
  document.addEventListener('shopify:section:load', initializeJumps);
})();
